"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _CardActions = _interopRequireDefault(require("@material-ui/core/CardActions"));

var _excluded = ["children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CardActions = function CardActions(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_CardActions.default, props, children);
};

var _default = CardActions;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0NhcmQvQ2FyZEFjdGlvbnMudHN4Il0sIm5hbWVzIjpbIkNhcmRBY3Rpb25zIiwiY2hpbGRyZW4iLCJwcm9wcyJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7Ozs7Ozs7Ozs7QUFHQSxJQUFNQSxXQUF1QyxHQUFHLFNBQTFDQSxXQUEwQztBQUFBLE1BQUdDLFFBQUgsUUFBR0EsUUFBSDtBQUFBLE1BQWdCQyxLQUFoQjs7QUFBQSxzQkFDOUMsNkJBQUMsb0JBQUQsRUFBb0JBLEtBQXBCLEVBQTRCRCxRQUE1QixDQUQ4QztBQUFBLENBQWhEOztlQUllRCxXIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IENhcmRBY3Rpb25zIGFzIE11aUNhcmRBY3Rpb25zLCBDYXJkQWN0aW9uc1Byb3BzIH0gZnJvbSAnQG1hdGVyaWFsLXVpL2NvcmUnO1xuXG5jb25zdCBDYXJkQWN0aW9uczogUmVhY3QuRkM8Q2FyZEFjdGlvbnNQcm9wcz4gPSAoeyBjaGlsZHJlbiwgLi4ucHJvcHMgfSkgPT4gKFxuICA8TXVpQ2FyZEFjdGlvbnMgey4uLnByb3BzfT57Y2hpbGRyZW59PC9NdWlDYXJkQWN0aW9ucz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IENhcmRBY3Rpb25zO1xuIl19